import React, { Fragment, useContext, useRef } from 'react';
import { visuallyHidden } from '@mui/utils';
import Script from 'next/script';
import makeStyles from '@mui/styles/makeStyles';
import CurrentPageContext from '@/components/context/CurrentPageData';
import ListingCTA from "@/components/02_molecules/ListingCTA/ListingCTA";
import Accordions from "@/components/02_molecules/Accordion";
import { listSaleStatus } from "@/helpers/listing_data";
import ListingStatus from "@/components/01_atoms/ListingStatus/ListingStatus";
import { Box, Button, Typography, Container, Grid } from "@mui/material";

import { composeListingStatus } from '@/helpers/listing';
import { composeSliderMedia } from '@/utils/transforms';
import Breadcrumbs from "@/components/01_atoms/Breadcrumbs";
import {componentList} from '@/api/global';
import SliderContainer from '@/components/03_organisms/ClientSideSliderContainer';
// const DynamicListingCarousel = componentList['CustomMuiMediaSlider']; // dynamic(() => import('../../03_organisms/CarouselMuiSlider'), { ssr: false });
const DynamicRelatedListings = componentList['TunnellContentGrid']; // dynamic(() => import('../../02_molecules/ContentList'));

const slickSettFeatured = {
  className: "center",
  centerMode: false,
  infinite: false,
  centerPadding: 0,
  speed: 500,
  rows: 2,
  slidesPerRow: 1,
  slidesToShow: 3,
  slidesToScroll: 1,
};

const slickSettSmall = {
  className: "center two-up-slider",
  centerMode: false,
  infinite: false,
  centerPadding: 0,
  speed: 1000,
  rows: 1,
  slidesPerRow: 1,
  slidesToShow: 2,
  slidesToScroll: 1,
};
const slickSettSingle = {
  className: "center",
  centerMode: false,
  infinite: false,
  centerPadding: 0,
  speed: 1000,
  rows: 1,
  slidesPerRow: 1,
  slidesToShow: 1,
  slidesToScroll: 1,
};

// To override/merge styles in CarouselHOC:
const useSliderStyles = makeStyles((theme) => ({
  rootCarousel: {},
}));

const useStyles = makeStyles((theme) => ({
  mapStyles: {
    border: 0,
  },
  addMargin: {
    margin: '1em'
  },
  embedVideoTab: {
    minHeight: '600px'
  }
}),
);

export default function ListingPage(props) {
  const classes = useStyles();

  // Use {sitewideContext?.site} to detect the site (potnets/baywoods)
  const sitewideContext = useContext(CurrentPageContext);

  const HOCCarouselstyles = useSliderStyles(props);

  const { node } = props;

  let slides, banner_status, custom_banner_status, fetchMltOpts, neighbor, city, comm, oh_arr;

  const schemaData = {
    "@context": "http://schema.org",
    "@type": "SingleFamilyResidence",
    "additionalType": "Product",
    "url": node?.alias ? `${process.env.NEXT_PUBLIC_FRONT_URL}${node?.alias}` : `${process.env.NEXT_PUBLIC_FRONT_URL}${node?.internal}`,
    "name": node?.address || node?.title,
    "description": node?.body,
    "accommodationCategory": 'RESI',
    "numberOfRooms": node?.sfhouse?.beds || node?.beds,
    "floorSize": {
      "@type": "QuantitativeValue",
      "@context": "http://schema.org",
      "value": node?.sfhouse?.sqft || node?.sqft,
      "unitCode": "FTK"
    },
    "numberOfBathroomsTotal": node?.sfhouse?.bathAll || node?.bathAll || 0,
    "numberOfBedrooms": node?.sfhouse?.beds || node?.beds || 0,
    "numberOfFullBathrooms": node?.sfhouse?.bathFull || node?.bathFull || 0,
    "numberOfPartialBathrooms": node?.sfhouse?.bathHalf || node?.bathHalf || 0,
    "yearBuilt": node?.sfhouse?.yearBuilt || node?.yearBuilt || 0,
    "address": {
      "@type": "PostalAddress",
      "@context": "http://schema.org",
      "contactType": "Business",
      "addressCountry": "US",
      "addressLocality": node?.sfhouse?.city || node?.city || "",
      // "addressRegion": node?.county || "",
      "postalCode": node?.sfhouse?.zip || node?.zip || "",
      "streetAddress": node?.sfhouse?.street || node?.street || ""
    },
    "latitude": node?.sfhouse?.lat || node?.lat,
    "longitude": node?.sfhouse?.lon || node?.lon,
    // "identifier": node?.mlsNum || "",
    "geo": { "@type": "GeoCoordinates", "@context": "http://schema.org", "latitude": node?.sfhouse?.lat, "longitude": node?.sfhouse?.lon },
    "photo": node?.imageOrig,
    "image": node?.imageOrig
  };

  if (node) {
    fetchMltOpts = {
      solrMltListings: true,
      internalId: node.internalId,
      lang: node?.lang || 'en',
      mlt_fields: `ss_sale_type,tm_X3b_${node?.lang || 'en'}_city`,
      // sort: [{dir: 'DESC', field: 'ds_modified'}],
    };

    // For "related listings"
    if (node.price > 0) {
      const price_distort = node.price * .25;
      fetchMltOpts = {
        ...fetchMltOpts,
        price_min: (node.price - price_distort) > 0 ? node.price - price_distort : 0,
        price_max: node.price + price_distort,
      };
    }

    if (node?.slides && node?.slides?.length > 0 && node.slides[0].src !== undefined) {
      slides = node.slides;
    }
    else {
      slides = composeSliderMedia(node?.slides);
    }

    // Format Banner status info:
    banner_status = composeListingStatus('Buy', listSaleStatus[node.homeStatus?.title], node.dateAvail, 1/*, node.ohDates*/);
    if (node.banner?.length > 0) {
      // Format CUSTOM additional Banner status info:
      custom_banner_status = composeListingStatus('Buy', listSaleStatus['Custom Banner'], null, 1, null, node.banner);
    }

    // Format Open House dates:
    // oh_arr = formatOpenHouseDates(node.ohDates);
  }
  else {
    return null;
  }

  //  https://cms.tunnellco.lndo.site/jsonapi/listings?include=domSrc%2ChomeStatus%2Cslides%2Cslides.imageFile%2Cimage%2Cimage.imageFile%2ClistingRef%2ClistingRef.commTerm&fields%5Blistings%5D=id%2CinternalId%2Cpath%2Ctitle%2Cprice%2ClistingRef%2Cslides%2Cimage%2ChomeStatus%2CsaleType%2CpropType&fields%5Bsfhouse%5D=id%2CinternalId%2Caddress%2CbathAll%2Cbeds%2Csqft%2ChomeLot%2CcommTerm&fields%5BimagesMls%5D=imageFile&fields%5Bfiles%5D=uri&sort=-price,-homeStatus.meta.drupal_internal__target_id,-changed&filter%5BisPublished%5D%5Bvalue%5D=1&filter%5BdomSrc.meta.drupal_internal__target_id%5D=baywoods&filter%5Bst%5D%5Bcondition%5D%5Boperator%5D=IN&filter%5Bst%5D%5Bcondition%5D%5Bpath%5D=saleType&filter%5Bst%5D%5Bcondition%5D%5Bvalue%5D%5B1%5D=Pre-Owned&filter%5Bhs%5D%5Bcondition%5D%5Boperator%5D=IN&filter%5Bhs%5D%5Bcondition%5D%5Bpath%5D=homeStatus.meta.drupal_internal__target_id&filter%5Bhs%5D%5Bcondition%5D%5Bvalue%5D%5B1%5D=25&filter%5Bhs%5D%5Bcondition%5D%5Bvalue%5D%5B2%5D=26&filter%5Bhs%5D%5Bcondition%5D%5Bvalue%5D%5B3%5D=27&filter%5Bhs%5D%5Bcondition%5D%5Bvalue%5D%5B4%5D=30&filter%5Bhs%5D%5Bcondition%5D%5Bvalue%5D%5B5%5D=38&filter%5Bhs%5D%5Bcondition%5D%5Bvalue%5D%5B6%5D=40&page%5Blimit%5D=24
  // Node BUNDLE = house_listing (JSON API = "listings"):
  let lq = {
    'include': 'domSrc,homeStatus,image,image.imageFile,listingRef,listingRef.commTerm',
    'fields[listings]': 'id,internalId,path,title,price,listingRef,image,homeStatus,saleType,propType,leaseFee,breadcrumbs,banner',
    'fields[sfhouse]': 'id,internalId,address,bathAll,beds,sqft,homeLot,homesite,commTerm,title',
    'fields[imagesMls]': 'imageFile',
    'fields[files]': 'uri',
    'sort': '-changed,-price,-homeStatus.meta.drupal_internal__target_id',
    'filter[isPublished][value]': 1,
    'filter[domSrc.meta.drupal_internal__target_id]': sitewideContext?.site,
  };
  // Node BUNDLE = listing (JSON API = "sfhouse"):
  if (node.bundle == 'listing') {
    lq = {
      'include': 'domSrc, commTerm',
      'fields[sfhouse]': 'id,internalId,address,bathAll,beds,sqft,homeLot,homesite,commTerm,title',
      'sort': '-changed,-price',
      'filter[isPublished][value]': 1,
      'filter[domSrc.meta.drupal_internal__target_id]': sitewideContext?.site,
    }
  }
  if (node?.sfhouse?.homeLot?.length > 0) {
    if (node?.sfhouse?.homeLot == 'Floor Plan') {
      lq = {
        ...lq,
        'filter[listingRef.homeLot]': 'Floor Plan',
      };
    }
  }
  if (node?.saleType?.length > 0) {
    lq = {
      ...lq,
      'filter[st][condition][operator]': 'IN',
      'filter[st][condition][path]': 'saleType',
      'filter[st][condition][value][1]': node.saleType,
    };
  }

  if (node?.homeStatus?.internalId > 0) {
    lq = {
      ...lq,
      'filter[hs][condition][operator]': 'IN',
      'filter[hs][condition][path]': 'homeStatus.meta.drupal_internal__target_id',
      'filter[hs][condition][value][1]': node?.homeStatus?.internalId,
    };
    [25, 40, 150, 234].map((h, i) => {
      lq[`filter[hs][condition][value][${i + 1}]`] = h;
    });
  }
  let new_block = {
    random: 4,
    perPage: 48,
    noPager: true,
    colMd: 3,
    spacing: 2,
    fetchOpts: {
      url: node.bundle == 'listing' ? `/sfhouse` : `/listings`,
      query: lq,
      opts: { type: 'api' },
    },
    comp: `TunnellListingCard`,
  };

  const fetchGalleryOpts = {
    init: 12,
    offset: 0,
    url: `${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL}/jsonapi/rest/view/listing-media?sf_ref=${node?.homeNum}`
  };

  const amenities_exist = node?.sfhouse?.amenities?.length > 0 || node?.sfhouse?.homesite?.length > 0
      || node?.sfhouse?.roomTypes?.length > 0 || node?.sfhouse?.driveway?.length > 0
      || node?.sfhouse?.heat?.length > 0 || node?.sfhouse?.yearBuilt > 0
      || node?.sfhouse?.deck || node?.sfhouse?.deck2 || node?.sfhouse?.porch || node?.sfhouse?.porch2
      || node?.sfhouse?.shed;

  // const gmapRef = useRef();
  // const gmapRefValue = useOnScreen(gmapRef);

  return <>
    <Script type="application/ld+json"
            key={`schema-json`} id={`schema-json`}
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData, null, "\t")}}
    />
    {Array.isArray(node?.breadcrumbs) && node?.breadcrumbs?.length > 0 &&
    <Breadcrumbs links={node.breadcrumbs} />
    }
    <Box py={4}>
      {(slides?.length > 0 && slides?.length < 2) &&
      <Box className="single-slide">
        <SliderContainer key={`slider-${node.internalId || node?.alias || node?.internal}`} classes={HOCCarouselstyles} slickSett={slickSettSingle}
                         showLight={true} fetchSlidesOpt={fetchGalleryOpts} slides={slides}
        ></SliderContainer>
      </Box>
      }

      {(slides?.length > 1 && slides?.length < 6) &&
      <Box style={{ minHeight: 400 }} >
        <SliderContainer key={`slider-${node.internalId || node?.alias || node?.internal}`} classes={HOCCarouselstyles} slickSett={slickSettSmall}
                         showLight={true} fetchSlidesOpt={fetchGalleryOpts} slides={slides}
        ></SliderContainer>
      </Box>
      }
      {(!slides?.length || slides?.length > 5) &&
      <Box style={{ minHeight: 400 }} >
        <SliderContainer key={`slider-${node.internalId || node?.alias || node?.internal}`} classes={HOCCarouselstyles} slickSett={slickSettFeatured} featured={true}
                         showLight={true} fetchSlidesOpt={fetchGalleryOpts} slides={slides}
        ></SliderContainer>
      </Box>
      }

      {banner_status !== null && banner_status?.status > 0 &&
      <ListingStatus style={{ minHeight: 54 }} {...banner_status}></ListingStatus>
      }
      {node.homeStatus?.title !== 'BG Sold' && custom_banner_status !== null && custom_banner_status?.status > 0 &&
      <ListingStatus custom style={{ minHeight: 54 }} {...custom_banner_status}></ListingStatus>
      }

      <ListingCTA node={node} ctaType={'sale'} />

      <Accordions bgColor='#eee' openFirst={true}>
        <span key={`acc-lbl-1`}>Property Details</span>
        <Fragment key={`acc-data-1`}>
          <span style={visuallyHidden} className={`invisible`}>Check this out!</span>
          {node.body?.length > 0 &&
          <Typography component={`section`} key={`body`} variant="body1" dangerouslySetInnerHTML={{ __html: `<div className="inner-html">${node.body}</div>` }} />
          }
          {(!node.body || node.body?.length < 1) &&
          <Typography variant="body1">
            Description is coming soon. Contact us for more details.
          </Typography>
          }
        </Fragment>

        <span key={`acc-lbl-2`} className={`${!amenities_exist ? 'hidden': ''}`}>Features</span>
        <div key={`acc-data-2`} className={`${!amenities_exist ? 'hidden': ''}`}>
          <Grid container direction="row">
            {node?.sfhouse?.amenities?.length > 0 &&
            <Grid item xs={12} md={6}>
              <ul>
                {
                  (node.sfhouse.amenities).map((v, i) => {
                    return (
                        <li>
                          <Typography variant="body2">{v}</Typography>
                        </li>
                    );
                  })
                }
              </ul>
            </Grid>
            }
            <Grid item xs={12} md={6} className={classes.addMargin}>
              {node?.sfhouse?.homesite?.length > 0 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'hs-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Homesite</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'hs-col2-2'}>
                  <Typography align="left" variant="body2">{node.sfhouse.homesite.join(', ')}</Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.roomTypes?.length > 0 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'rt-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Room Types</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'rt-col2-2'}>
                  <Typography align="left" variant="body2">{node.sfhouse.roomTypes.join(', ')}</Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.driveway?.length > 0 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'dr-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Driveway</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'dr-col2-2'}>
                  <Typography align="left" variant="body2">{node.sfhouse.driveway.join(', ')}</Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.heat?.length > 0 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'heat-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Heat</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'heat-col2-2'}>
                  <Typography align="left" variant="body2">{node.sfhouse.heat.join(', ')}</Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.yearBuilt > 0 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'year-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Year Built</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'year-col2-2'}>
                  <Typography align="left" variant="body2">{node.sfhouse.yearBuilt}</Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.deck &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'deck-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Deck</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'deck-col2-2'}>
                  <Typography align="left" variant="body2">
                    Width: {node?.sfhouse?.deck.first} &nbsp;&nbsp; Length: {node?.sfhouse?.deck.second}
                  </Typography>
                </Grid>
              </Grid>
              }
              {node?.sfhouse?.deck2 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'deck2-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Deck 2</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'deck2-col2-2'}>
                  <Typography align="left" variant="body2">
                    Width: {node?.sfhouse?.deck2.first} &nbsp;&nbsp; Length: {node?.sfhouse?.deck2.second}
                  </Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.porch &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'porch-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Porch</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'porch-col2-2'}>
                  <Typography align="left" variant="body2">
                    Width: {node?.sfhouse?.porch.first} &nbsp;&nbsp; Length: {node?.sfhouse?.porch.second}
                  </Typography>
                </Grid>
              </Grid>
              }
              {node?.sfhouse?.porch2 &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'porch2-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Porch 2</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'porch2-col2-2'}>
                  <Typography align="left" variant="body2">
                    Width: {node?.sfhouse?.porch2.first} &nbsp;&nbsp; Length: {node?.sfhouse?.porch2.second}
                  </Typography>
                </Grid>
              </Grid>
              }

              {node?.sfhouse?.shed &&
              <Grid container>
                <Grid item xs={4} sm={4} align="left" key={'shed-col2-1'}>
                  <Typography align="left" variant="body2"><strong>Shed</strong></Typography>
                </Grid>
                <Grid item xs={8} sm={8} className="listingDetail" key={'shed-col2-2'}>
                  {node?.sfhouse?.electricity &&
                  <>
                    <Typography align="left" variant="body2">Shed with electricity</Typography>
                    <br />
                  </>
                  }
                  <Typography align="left" variant="body2">
                    Width: {node?.sfhouse?.shed.first} &nbsp;&nbsp; Length: {node?.sfhouse?.shed.second}
                  </Typography>
                </Grid>
              </Grid>
              }
            </Grid>
          </Grid>
        </div>

        <span key={`acc-lbl-3`} className={`${!node.videoEmbed ? 'hidden': ''}`}>Property Video</span>
        <div id="videoDiv" key={`acc-data-3`} className={`${!node.videoEmbed ? 'hidden': classes.embedVideoTab}`}>
          {/* Check embed URL for Vimeo: https://vimeo.com/api/oembed.json?url=https://vimeo.com/799590705/8b58d1b31b */}
            {node.videoEmbed?.length > 0 &&
              <iframe frameBorder="0" allow='autoplay' height="500" width="100%"
              className={`embed-video`}
              htmlallow="autoplay; fullscreen; picture-in-picture" allowFullScreen={true}
              src={node.videoEmbed} // ?autoplay=1&loop=1&autopause=0&mute=1&title=0&byline=0&portrait=0
              title="Listing video" />
            }
        </div>
      </Accordions>

      {/* Lazyload the map section if it scrolls into visible area.
      @see: https://betterprogramming.pub/lazy-loading-in-next-js-simplified-435681afb18a
    */}
      {/*<div ref={gmapRef}>*/}
      {!['Floor Plan', 'Inventory Home'].includes(node.saleType) && sitewideContext?.site == 'potnets' &&
      <iframe key={`list-map`}
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyD6NBGpPy6fOEzRamqO2BPbot867DCoEHM&q=${node.sfhouse?.street?.replace(/ /g, '+')},${node.sfhouse?.city?.replace(/ /g, '+')},${node.sfhouse?.zip}&zoom=17`}
              width="100%" height="300" allowFullScreen={true}
              frameBorder="0" loading="lazy" className={classes.mapStyles}
              title="Map"></iframe>
      }
      {!['Floor Plan', 'Inventory Home'].includes(node.saleType) && sitewideContext?.site == 'baywoods' &&
      <iframe key={`list-map`}
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyD6NBGpPy6fOEzRamqO2BPbot867DCoEHM&q=${node.sfhouse?.street?.replace(/ /g, '+')},${node.sfhouse?.city?.replace(/ /g, '+')},${node.sfhouse?.zip}&zoom=17`}
              width="100%" height="300" allowFullScreen={true}
              frameBorder="0" loading="lazy" className={classes.mapStyles}
              title="Map"></iframe>
      }
      {/*</div>*/}

      {/* {sitewideContext?.site == 'baywoods' && (node.saleType === 'Floor Plan' || node.saleType === 'Inventory Home') &&
      <>
        <TimeModal width={450} height={980} embed="https://fs3.formsite.com/g4S24p/7bpmt8klcc/index.html" title="Contact Sales"></TimeModal>

        <FormCta id={`contact-sales`} node={{
          height: '1200',
          imageOrig: '/assets/baywood-greens-logo.svg',
          imgAlt: 'Alternative Text',
          embed: 'https://fs3.formsite.com/g4S24p/9vcgsi4ot7/index.html'
        }}
        />
      </>
    } */}

      {/* {sitewideContext?.site == 'potnets' &&
      <Box bgcolor="secondary.light">
        <FormCta id={`contact-sales`} node={{
          title: 'Contact Sales Regarding a Property',
          imageOrig: '/assets/pot-nets.svg',
          imgAlt: 'Alternative Text',
          height: 680,
          embed: 'https://fs3.formsite.com/g4S24p/dcmm8afprx/index.html'
        }} />

        <TimeModal width={450} height={680} embed="https://fs3.formsite.com/g4S24p/dcmm8afprx/index.html" title="Contact Sales"></TimeModal>

      </Box>
    } */}
    </Box>

    <Box py={5} textAlign={`center`} display="block" displayPrint="none">
      <Typography gutterBottom align="center" variant={`h2`}>
        Related Homes<br /><br />
      </Typography>
      <DynamicRelatedListings block={new_block} key={`related-list`} noresult={<SearchNoResults />} />
      <Box mt={5}>
        <Button disableElevation variant="contained" color="primary"
                href={sitewideContext?.site == 'potnets' ? '/homes' : '/living/homes'}>View More</Button>
      </Box></Box>
  </>;
}

const SearchNoResults = () => {
  return (
      <Typography component={`p`}>Seems like we didn't find similar properties based on the current one.<br/>
        But you can explore all that we have in store!
      </Typography>
  );
}

